import Marquee from "react-fast-marquee";

const items = ["POLYONPEPS.COM", ">99% PURITY", "LAB TESTED", "POLYONPEPS.COM", "COLD-CHAIN SHIPPED", "RESEARCH GRADE"];

export default function TickerMarquee() {
  return (
    <div className="border-y border-white/10 bg-[#050507] py-6" data-testid="ticker-marquee">
      <Marquee speed={60} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 font-display font-black text-3xl md:text-5xl uppercase tracking-tighter stroke-text flex items-center gap-8">
            {t} <span className="text-[#00F0FF] text-xl not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
